'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = warnOnce;
var printed = {};

function warnOnce(message) {
    if (printed[message]) return;
    printed[message] = true;

    if (typeof console !== 'undefined' && console.warn) console.warn(message);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/styled-components/lib/vendor/postcss/warn-once.js
// module id = 57
// module chunks = 0